import Backbone from "backbone";
import BaseApiModel from "scripts/models/baseApiModel";
import UnauthorizedSyncError from "scripts/exceptions/unauthorizedSyncError";
import UnsentSyncError from "scripts/exceptions/unsentSyncError";

const chan = Backbone.Radio.channel;

class AudioListenEventModel extends BaseApiModel {
  constructor(attrs, options) {
    super(attrs, options);

    this.setDefaultModelProperties();
  }

  setDefaultModelProperties() {
    this.set({
      sessionId: chan("security").request("user").getToken(),
    });
  }

  url() {
    return `${this.apiUrlRoot}/tracking/audiobook-event`;
  }

  bugsnagError(error) {
    if (
      !(error instanceof UnauthorizedSyncError) &&
      !(error instanceof UnsentSyncError)
    ) {
      chan("bugsnag").request("notify", error);
    }

    throw error;
  }
}

export default AudioListenEventModel;
